<span [class.focused]="isFocused && active"
      [class.selected]="selected"
      class="drop-shadow-lg tk-proxima-nova-wide"
      mat-ripple>
  {{ label }}
</span>
